import {
  EN_DASH,
  NON_BREAKING_SPACE,
  ADA_SYMBOL,
  ALMOST_EQUAL_TO,
} from "./constants";

const numberFormat = new Intl.NumberFormat("en-US", {
  notation: "compact",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

type OwnProps = {
  as: "div" | "span";
  lovelaceAmount: bigint | number | null | undefined;
  approx?: boolean;
};

type ForwardedProps = Omit<
  React.HTMLAttributes<HTMLDivElement & HTMLSpanElement>,
  keyof OwnProps
>;

type Props = OwnProps & ForwardedProps;

/** @deprecated use `@/modules/common-utils/format` instead */
export function AssetViewer$Ada$Compact({
  as,
  lovelaceAmount,
  approx,
  ...others
}: Props) {
  const Component = as;

  if (lovelaceAmount == null) {
    return <Component {...others}>{EN_DASH}</Component>;
  }

  const title = `${lovelaceAmount} lovelaces`;

  if (lovelaceAmount > 0 && lovelaceAmount < 5000) {
    // less than 0.005 ADA
    return (
      <Component title={title} {...others}>
        {"<" + "0.01" + NON_BREAKING_SPACE + ADA_SYMBOL}
      </Component>
    );
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format#using_format_with_a_string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const infix = numberFormat.format(`${lovelaceAmount}E-6` as any);
  const prefix = approx ? ALMOST_EQUAL_TO + NON_BREAKING_SPACE : "";
  const suffix = NON_BREAKING_SPACE + ADA_SYMBOL;

  return (
    <Component title={title} {...others}>
      {prefix + infix + suffix}
    </Component>
  );
}
